import StartJourney from "./startJourney"

export default StartJourney
